import {observable} from 'mobx';
import Message from './Message';
import {splitLocale} from '~/utils/tools';

class MessageApps {
  id;

  name;

  count;

  linkedAppId;

  linkedMenuCode;

  linkedStates;

  @observable
  messages = [];

  updateFromJson(json) {
    this.id = json.id;
    if (typeof json.name === 'string') {
      this.name = json.name;
    } else {
      this.name = splitLocale(json.name);
    }
    this.count = json.count;
    this.linkedAppId = json.linkedAppId;
    this.linkedMenuCode = json.linkedMenuCode;
    this.linkedStates = json.linkedStates;

    if (json.messages) {
      this.messages = json.messages.map((item) => {
        const message = new Message(this, item);
        message.updateFromJson(item);
        return message;
      });
    }
  }
}
export default MessageApps;
